import { render, staticRenderFns } from "./NumberSelector.vue?vue&type=template&id=279a07d6&scoped=true&"
import script from "./NumberSelector.vue?vue&type=script&lang=ts&"
export * from "./NumberSelector.vue?vue&type=script&lang=ts&"
import style0 from "./NumberSelector.vue?vue&type=style&index=0&id=279a07d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279a07d6",
  null
  
)

export default component.exports